export default "dist/furniture/bkgd_code_canvas.png";